// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"015fc873f7a69ce5a0fc","303":"31208fb9f696678df0a6","495":"701d2ef83f3c23fe6c64"}[chunkId] + ".js";
};